import { Grid } from "@mui/material";
import { Tabs, Tab } from "react-bootstrap";
import { isMobileDevice, toastError } from "../../commons/utils";
import { Column } from "primereact/column";
import { DashColetas } from "./Coletas";
import './styles.css';
import { useEffect, useRef, useState } from "react";
import { useAuth } from "../../contexts/AuthProvider/useAuth";
import { toast } from "react-toastify";
import { DashAnomalias } from "./Anomalias";

export const GridCard = (props: any) => {
    return (
        <Grid item xs={isMobileDevice() ? 12 : props.md ? props.md : 3}>
            {props.children}
        </Grid>
    )
}

export const Columns = (columns: any) => {
    return columns?.map((col: any, i: number) => (
        <Column
            key={col.field}
            field={col.field}
            align={isMobileDevice() || col.dataType === 'numeric' ? 'right' : 'left'}
            header={col.header}
            body={col.body}
            sortable={true}
            style={{ ...col.style, fontSize: '12px', marginBottom: `${i + 1 === columns.length ? '0px' : '-14px'}` }}
        />
    ));
};

export const Dashboard = () => {
    const auth = useAuth();

    const [activeTab, setActiveTab] = useState<string>("coletas");

    const refEntrada = useRef<any>(null);
    const refAnomalias = useRef<any>(null);
    const refVisible = useRef(true)
    const refTimeout = useRef<NodeJS.Timeout>(null)

    async function getColetas() {
        try {
            const entradaResponse: any = await auth.get('/v1/coletaindicadorreport');
            const coletaResponse: any = await auth.get('/v1/programacaocoletareport');

            refEntrada.current.setData(entradaResponse.data, coletaResponse.data);
        } catch (error) {
            console.log(error);
            toast.error('Erro ao executar a operação.');
        }
    }

    async function getAnomlias() {
        try {
             const anomaliasResponse: any = await auth.get('/v1/anomaliasreport');
            const usuariosResponse: any = await auth.get('/v1/usuariosreport');

            refAnomalias.current.setData(anomaliasResponse.data, usuariosResponse.data);
        } catch (error) {
            console.log(error);
            toast.error('Erro ao executar a operação.');
        }
    }

    async function loadTabData(tab: string | null) {
        if (refVisible.current) {
            refTimeout.current && clearTimeout(refTimeout.current)

            refTimeout.current = setTimeout(() => {
                refTimeout.current = null
                loadTabData(tab)
            }, 60000);
        }

        if (!tab) return;

        try {
            if (tab === "coletas") await getColetas()
            if (tab === "anomalias") await getAnomlias()
        } catch (error) {
            toastError(error);
        }
    }

    useEffect(() => {
        loadTabData(activeTab);

        const handleVisibilityChange = () => {
            refVisible.current = document.visibilityState === "visible"

            if (document.visibilityState === "visible" && !refTimeout.current)
                loadTabData(activeTab)
        };

        document.addEventListener('visibilitychange', handleVisibilityChange)

        return () => document.removeEventListener('visibilitychange', handleVisibilityChange)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <Tabs
            activeKey={activeTab}
            onSelect={(tab) => {
                if (!tab) return;

                setActiveTab(tab);
                loadTabData(tab);
            }}
            style={{ padding: isMobileDevice() ? "1rem" : ".8rem 2rem" }}
        >
            <Tab eventKey="coletas" title="Indicadores" style={{ backgroundColor: 'var(--bg-color-secondary)' }}>
                <DashColetas ref={refEntrada} />
            </Tab>
            <Tab eventKey="anomalias" title="Anomalias" style={{ backgroundColor: 'var(--bg-color-secondary)' }}>
                <DashAnomalias ref={refAnomalias} />
            </Tab>
        </Tabs>
    );
}
